import React from 'react'
import classnames from 'classnames'
import { component_tool } from '@/tool'
import { Icon } from 'antd';
import { QsRadio, QsCheckbox, QsSelect, QsInput, QsTextarea, QsRate } from './components'
import { WizPhoneCall, WizCallLog } from "@/containers/common";
const { WizComponent, Wizmessage, WizModal } = component_tool;

const Comp = (props) => {
  const { CompName, index, title, required, tips, data, openPhone, openCallLog, yunCall, ...otherProps } = props
  console.log(otherProps, 'otherProps')
  const judgePhone = () => {
    const phoneReg = /^1[34578]\d{9}/;
    if (phoneReg.test(otherProps.answer)) {
      openPhone(otherProps, index + 1, data)
    } else {
      Wizmessage.error('手机号不正确，请确认重试');
    }
  }
  return (
    <div className={classnames("qs-item", !props.preview ? "normal" : null)}>
      <div className="qs-item-title">
        <strong>{index + 1}、{title}</strong>{required ? <span className="qs-item-required">*</span> : null}
        {yunCall && title && (title.indexOf('手机') > -1 || title.indexOf('电话') > -1) ?
          <>
            <img src={constants.files.sys_phone_icon} className="phone-call-icon" onClick={() => judgePhone()} />
            <img src={constants.files.sys_phone_log_icon} className="phone-call-log-icon" onClick={() => openCallLog()}></img>
          </>
          : null}
      </div>
      <div className="survey-item-tips">{tips}</div>
      <div className="qs-item-content">
        {
          !props.preview ? <div className="answer"><CompName {...otherProps} /></div> : <CompName {...otherProps} />
        }
      </div>
    </div>
  )
}

export default class CreateQuestion extends WizComponent {
  constructor(props) {
    super(props)
    this.state = {
      callModalShow: false,
      quesRecord: {},
      callLogShow: false,
    }
  }
  openPhone = (other, qIndex, data) => {
    this.setState({ callModalShow: true, quesRecord: { ...data, mobile: other.answer, qIndex: qIndex } })
  }
  openCallLog = () => {
    this.setState({ callLogShow: true })
  }
  render() {
    console.log(this.props, 'this.props')
    const { preview, questions, yunCall, outEntityType, aboutType,parentEntityId, data } = this.props
    const { callModalShow, quesRecord, callLogShow } = this.state
    const Comps = questions && questions.map((val, index) => {
      let comp = null;
      const otherProps = {
        key: val.id,
        data,
        index,
        preview,
        yunCall,
        openPhone: this.openPhone,
        openCallLog: this.openCallLog,
        ...val
      }
      switch (val.type) {
        case 0:
          comp = <Comp CompName={QsRadio} {...otherProps} /> //单选题
          break;
        case 1:
          comp = <Comp CompName={QsCheckbox} {...otherProps} /> //多选题
          break;
        case 2:
          comp = <Comp CompName={QsSelect} {...otherProps} /> //下拉题
          break;
        case 3:
        case 4:
          comp = <Comp CompName={QsInput} {...otherProps} /> //填空题 //单行文本题
          break;
        case 5:
          comp = <Comp CompName={QsTextarea} {...otherProps} /> //多行文本题
          break;
        case 6:
          comp = <Comp CompName={QsRate} {...otherProps} /> //评分题
          break;
      }
      return comp
    })

    return (
      <div className="question-content">
        {Comps}
        {callModalShow ? <WizPhoneCall innerQues={true} callScene={2} modalShow={callModalShow} entityType={outEntityType ? outEntityType : 6}
        record={quesRecord} parentEntityId={parentEntityId?parentEntityId:quesRecord.surveyId} closeModal={() => this.setState({ callModalShow: false })} /> : null}
        <WizModal title='通话记录' destroyOnClose={true} visible={callLogShow} footer={null} onCancel={() => this.setState({ callLogShow: false })} width={850}>
          <WizCallLog innerQues={true} entityType={aboutType ? aboutType : 6}
            entityTypeList={[6, 7]}
            entityId={data.id} parentEntityId={parentEntityId?parentEntityId:data.surveyId} />
        </WizModal>
      </div>
    )
  }
}

